import { Link } from 'react-router-dom';
import { categories } from '@/mocks/resources';

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-stack-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">无码专区</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed">
              精选资源聚合平台，为设计师和创作者提供海量高清无水印素材。分类清晰、更新及时、完全免费。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              <a href="#footer-categories" className="text-background-50">资源分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              <a href="#footer-links" className="text-background-50">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">常见问题</a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">联系我们</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              <a href="#footer-contact" className="text-background-50">关注我们</a>
            </h4>
            <p className="text-sm text-background-50/60 mb-4">
              每日更新优质资源，不错过任何精彩内容
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-wechat-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-bilibili-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-mail-line text-background-50"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; 2024 无码专区. All rights reserved.
          </p>
          <p className="text-sm text-background-50/40">
            精选资源聚合平台 — 为创作者而生
          </p>
        </div>
      </div>
    </footer>
  );
}